<template>
  <div class="app">
    <router-view />
  </div>
</template>

<style>
:root {
  --bg: #f5f6f8;
  --fg: #1a1a1a;
  --primary: #1f2a44;
  --accent: #4a82d6;
  --good: #2c9c4a;
  --warn: #f0a000;
  --bad: #d33;
  --muted: #888;
  --card: #fff;
  --border: #e3e6eb;
}
* { box-sizing: border-box; }
html, body, #app { height: 100%; margin: 0; padding: 0; }
body { font: 14px/1.5 -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; color: var(--fg); background: var(--bg); }
.app { height: 100%; }
</style>
